export default __webpack_public_path__ + "static/logo-7181aec80bdb640fc7985479606a5a4d.png";